const categories = [
  {
    id: 0,
    category: '구이용',
    checked: true,
  },
  {
    id: 1,
    category: '요리용',
    checked: false,
  },
  {
    id: 2,
    category: '피그로인',
    checked: false,
  },
  {
    id: 3,
    category: '세트상품',
    checked: false,
  },
  {
    id: 4,
    category: '설날선물세트',
    checked: false,
  },
  {
    id: 5,
    category: '샤쿼테리',
    checked: false,
  },
  {
    id: 6,
    category: '가니쉬',
    checked: false,
  },
  {
    id: 7,
    category: '시즈닝',
    checked: false,
  },
];

const filterTags = [
  {
    id: 0,
    tag: '베스트',
  },
  {
    id: 1,
    tag: '베나라',
  },
  {
    id: 2,
    tag: '베베',
  },
  {
    id: 3,
    tag: '배놔라',
  },
  {
    id: 4,
    tag: '감놔라',
  },
];

const productCode = 'sir-12345';

const stock = '22';

export { categories, filterTags, productCode, stock };
